import { jsx as d } from "react/jsx-runtime";
import { c as x } from "./index-65016bfa.mjs";
import p, { css as b } from "styled-components";
import "@fcamna/shared-component-foundations";
import "react";
import { u as N } from "./useQuantum-50e8fd44.mjs";
import "./isClient-ec947a14.mjs";
import "./useSlots-a1aa6a84.mjs";
import "./_commonjsHelpers-92157f1b.mjs";
const C = p.div`
  &.MediaDisclosureButton {
    ${({
  theme: {
    components: { mediaDisclosureButton: t }
  },
  $styles: s
}) => b(t.DisclosureButtonsContainer, s)};
  }
`, M = p.button`
  &.DisclosureButton {
    ${({
  theme: {
    components: { mediaDisclosureButton: t }
  }
}) => b(t.DisclosureButton)};
  }
`, K = ({
  id: t,
  links: s = [],
  accessibilityOption: l,
  itemGap: m = "8px",
  alignment: D = "bottom-right",
  style: f,
  className: B,
  containerPosition: e = {
    left: "20px",
    right: "20px",
    bottom: "16px"
  }
}) => {
  var u;
  const h = N({ label: "Media Disclosure Button" });
  if (!s.length)
    return null;
  const k = (o, g) => {
    var a, c;
    return /* @__PURE__ */ d(
      M,
      {
        id: o.id,
        type: "button",
        className: "DisclosureButton",
        "data-disclosure-number": o.disclosureNumber || isNaN(parseInt(`${o.linkTitle}`)) ? g + 1 : parseInt(`${o.linkTitle}`),
        "aria-label": (c = (a = o.accessibilityOption) == null ? void 0 : a.button) == null ? void 0 : c.ariaLabel,
        onClick: (r) => {
          var n;
          return (n = o.onClick) == null ? void 0 : n.call(o, r, o.id);
        },
        onKeyDown: (r) => {
          var i;
          (r.code === "Enter" || r.code === "Space") && ((i = o.onClick) == null || i.call(o, r, o.id));
        },
        children: o.linkTitle
      },
      o.linkTitle
    );
  };
  return /* @__PURE__ */ d(
    C,
    {
      id: t,
      "aria-label": (u = l == null ? void 0 : l.div) == null ? void 0 : u.ariaLabel,
      $styles: {
        gap: m,
        bottom: e.bottom,
        ...D === "bottom-left" ? { left: e.left } : { right: e.right }
      },
      style: f,
      className: x(["MediaDisclosureButton", B]),
      ...h,
      children: s.map(k)
    }
  );
};
export {
  K as MediaDisclosureButton
};
